import { useMemo, useState } from "react";
import Map, { Marker, Popup } from "react-map-gl/mapbox";
import "mapbox-gl/dist/mapbox-gl.css";

export default function ExperiencesWithMap({ experiences = [], onPinClick }) {
  const [popupId, setPopupId] = useState(null);

  // ✅ Filter ONLY valid coordinates
  const validExperiences = useMemo(() => {
    return experiences.filter(
      (exp) =>
        exp?.location &&
        typeof exp.location.latitude === "number" &&
        typeof exp.location.longitude === "number" &&
        !isNaN(exp.location.latitude) &&
        !isNaN(exp.location.longitude)
    );
  }, [experiences]);

  // ✅ Safe initial map view
  const initialViewState = useMemo(() => {
    if (validExperiences.length > 0) {
      return {
        latitude: validExperiences[0].location.latitude,
        longitude: validExperiences[0].location.longitude,
        zoom: 12,
      };
    }

    return {
      latitude: 25.1972,
      longitude: 55.2744,
      zoom: 3,
    };
  }, [validExperiences]);

  if (validExperiences.length === 0) {
    return (
      <div className="h-full flex items-center justify-center text-gray-500">
        No map locations available
      </div>
    );
  }

  const selectedExp = validExperiences.find((x) => x.experienceId === popupId);

  return (
    <div className="w-full h-full rounded-xl overflow-hidden">
      <Map
        mapboxAccessToken="pk.eyJ1IjoidG91Y2FuLWhxIiwiYSI6ImNtanhobm42ZTZuNXIzZW90Nnd5ZnRkYzcifQ.rsaCfCYMlW2zBiAyb5tm-g"
        initialViewState={initialViewState}
        mapStyle="mapbox://styles/mapbox/streets-v11"
      >
        {validExperiences.map((exp) => {
          const isActive = popupId === exp.experienceId;

          return (
            <Marker
              key={exp.experienceId}
              latitude={exp.location.latitude}
              longitude={exp.location.longitude}
              anchor="bottom"
              onClick={(e) => {
                e.originalEvent.stopPropagation();
                onPinClick(exp.experienceId);
              }}
            >
              {/* 🔥 PIN SVG */}
              <svg
                width={isActive ? 50 : 40}
                height={isActive ? 50 : 40}
                viewBox="0 0 24 24"
                fill={"#06B6C9"}
                style={{
                  cursor: "pointer",
                  transform: isActive ? "scale(1.15)" : "scale(1)",
                  transition: "all 0.2s ease",
                }}
              >
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z" />
              </svg>
            </Marker>
          );
        })}

        {selectedExp && (
          <Popup
            closeOnClick={false}
            onClose={() => setPopupId(null)}
            latitude={selectedExp.location.latitude}
            longitude={selectedExp.location.longitude}
          >
            <p className="text-sm font-medium">{selectedExp.title}</p>
            <p className="text-xs text-gray-500">
              {selectedExp.location.city}, {selectedExp.location.country}
            </p>
          </Popup>
        )}
      </Map>
    </div>
  );
}
